module.exports = __webpack_public_path__ + "img/estonia.aa70a019.svg";